<template>
  <div v-if="field.options" class="select-field">
    <label class="subtitle-2 black--text pl-3">
      {{ field.label }}
      <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
      <v-select
        v-model="model"
        :placeholder="field.config.placeholder"
        @change="update()"
        :items="field.options"
        :error-messages.sync="block.errorMessages"
        item-text="id"
        item-value="value"
        class="pt-1"
        :clearable="true"
      >
        <template
          slot="selection"
          slot-scope="data"
        >{{ data.item.label }} {{ (data.item.upcharge)?'( + ' + data.item.upcharge + ' CHF) ':'' }}</template>
        <template
          slot="item"
          slot-scope="data"
        >{{ data.item.label }} {{ (data.item.upcharge)?'( + ' + data.item.upcharge + ' CHF) ':'' }}</template>
      </v-select>
      <div class="hint" v-if="field.hint">{{field.hint}}</div>
    </label>
  </div>
</template>
<script>
import FieldMixin from "./FieldMixin";
export default {
  mixins: [FieldMixin],
  name: "FieldSelect",

  methods: {
    validate: function() {
      this.errorMessages = [];
      if (this.field.required === 1 && !this.model) {
        this.isValid = false;
        this.addError(this.block.id,"Champ obligatoire");

      } else {
        this.isValid = true;
      }
    }
  }
};
</script>

<style lang="less">
.select-field {
  /deep/ .v-select__slot {
    border-color: #e8e8e8;
    background-color: #e8e8e8;
    border-radius: 20px;
    padding: 0.2rem 0.5rem;
  }
}
</style>